export default __webpack_public_path__ + "static/media/bannerBg.427e298b.png";